import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/screens/Home";
import Game from "@/screens/Game";
import Settings from "@/screens/Settings";
import Diagnostics from "@/screens/Diagnostics";
import HowToPlay from "@/screens/HowToPlay";
import Accessibility from "@/screens/Accessibility";
import Info from "@/screens/Info";
import Privacy from "@/screens/Privacy";
import Leaderboard from "@/screens/Leaderboard";

function App() {
  return (
    <div className="ag-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/game" element={<Game />} />
          <Route path="/classifica" element={<Leaderboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/come-si-gioca" element={<HowToPlay />} />
          <Route path="/accessibilita" element={<Accessibility />} />
          <Route path="/info" element={<Info />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/diagnostics" element={<Diagnostics />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
